import { lazy } from 'react';

// Pages publiques lourdes
export const Checkout = lazy(() =>
  import('@/pages/public/Checkout').then((m) => ({ default: m.Checkout }))
);

// Pages admin (code-split)
export const Dashboard = lazy(() =>
  import('@/pages/admin/Dashboard').then((m) => ({ default: m.Dashboard }))
);
export const Commandes = lazy(() =>
  import('@/pages/admin/Commandes').then((m) => ({ default: m.Commandes }))
);
export const Clients = lazy(() =>
  import('@/pages/admin/Clients').then((m) => ({ default: m.Clients }))
);
export const CodePromo = lazy(() =>
  import('@/pages/admin/CodePromo').then((m) => ({ default: m.CodePromo }))
);
export const Categories = lazy(() =>
  import('@/pages/admin/Categories').then((m) => ({ default: m.Categories }))
);
export const Transaction = lazy(() =>
  import('@/pages/admin/Transaction').then((m) => ({ default: m.Transaction }))
);
export const Rapport = lazy(() =>
  import('@/pages/admin/Rapport').then((m) => ({ default: m.Rapport }))
);
export const AjouterProduit = lazy(() =>
  import('@/pages/admin/AjouterProduit').then((m) => ({ default: m.AjouterProduit }))
);
export const ListeProduits = lazy(() =>
  import('@/pages/admin/ListeProduits').then((m) => ({ default: m.ListeProduits }))
);
export const GestionStock = lazy(() =>
  import('@/pages/admin/GestionStock').then((m) => ({ default: m.GestionStock }))
);
export const AvisProduits = lazy(() =>
  import('@/pages/admin/AvisProduits').then((m) => ({ default: m.AvisProduits }))
);
export const Parametres = lazy(() =>
  import('@/pages/admin/Parametres').then((m) => ({ default: m.Parametres }))
);
export const AutoriteControle = lazy(() =>
  import('@/pages/admin/AutoriteControle').then((m) => ({ default: m.AutoriteControle }))
);
export const ListeFactures = lazy(() =>
  import('@/pages/admin/ListeFactures').then((m) => ({ default: m.ListeFactures }))
);
export const DetailFacture = lazy(() =>
  import('@/pages/admin/DetailFacture').then((m) => ({ default: m.DetailFacture }))
);
export const CustomerBehavior = lazy(() =>
  import('@/pages/admin/CustomerBehavior').then((m) => ({ default: m.CustomerBehavior }))
);
export const FAQPage = lazy(() =>
  import('@/pages/admin/FAQ').then((m) => ({ default: m.FAQPage }))
);
export const TestimonialsPage = lazy(() =>
  import('@/pages/admin/Testimonials').then((m) => ({ default: m.TestimonialsPage }))
);
export const HomeBoxes = lazy(() =>
  import('@/pages/admin/HomeBoxes').then((m) => ({ default: m.HomeBoxes }))
);
export const HomeComingBoxes = lazy(() =>
  import('@/pages/admin/HomeComingBoxes').then((m) => ({ default: m.HomeComingBoxes }))
);
export const UsersList = lazy(() =>
  import('@/pages/admin/UsersList').then((m) => ({ default: m.UsersList }))
);
